import { render, staticRenderFns } from "./m_cis_business2024.vue?vue&type=template&id=29444227&scoped=true"
import script from "./m_cis_business2024.vue?vue&type=script&lang=js"
export * from "./m_cis_business2024.vue?vue&type=script&lang=js"
import style0 from "./m_cis_business2024.vue?vue&type=style&index=0&id=29444227&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29444227",
  null
  
)

export default component.exports